<script lang="ts">
    import RetailerInfo from '@components/retailer-info/RetailerInfo.svelte';

    import type { RetailerDto } from './types';

    let { data }: { data: RetailerDto } = $props();
</script>

<RetailerInfo retailer={data.retailer} />

<style>
</style>
